import BaseService from "./Base"
import {get} from "lodash"

class StudentStaffContactRolesServiceV3 extends BaseService {
    getAll = async (params = {}) => {
        const response = await this.post("/v1/student-staff-contact-roles/list", {
            ...params,
            sort: {
                orderBy: "name",
                orderDir: "asc"
            }
        })
        return get(response, "data", [])
    }
}
export default StudentStaffContactRolesServiceV3
